import React from 'react';
import { Reveal } from './Reveal';
const bonuses = [{
  title: 'Classroom Décor & Display Pack',
  description: 'Bring your geography room to life',
  price: '$37',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/fe0c0776-e95f-4911-b837-deb7a3176fa6.jpg'
}, {
  title: 'Assessments, Rubrics & Mark Schemes Pack',
  description: 'Stress-free marking, done for you',
  price: '$47',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/b57dbb6d-3f7b-4747-81ba-0308e87679d8.jpg'
}, {
  title: 'Progress Tracker & Certificates',
  description: 'Keep students motivated all year',
  price: '$27',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/e7b44204-1d4d-4d5c-86bd-681eb13334df.jpg'
}, {
  title: 'Emergency Sub Lessons Pack',
  description: 'A ready lesson for any last-minute cover',
  price: '$37',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/547f591d-9773-4ffa-81e2-7179345c6e74.jpg'
}, {
  title: 'Geography Games & Quizzes Pack',
  description: 'Learning that feels like play',
  price: '$37',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/4302fe64-f252-462d-86b4-9d71f1ecc336.jpg'
}];
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-17" data-mp="2lcoc3ww3fqy">
      <Reveal className="mx-auto max-w-3xl" data-id="element-18" data-mp="2nyvw3js5v96">
        <div className="mb-12 text-center" data-id="element-19" data-mp="7lqm8t4s19b9">
          <div className="inline-flex rounded-full bg-brand-teal/15 px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-teal" data-id="element-20" data-mp="7imb1bsw9db3">INCLUDED FREE TODAY</div>
          <h2 className="mt-4 text-3xl font-black text-brand-blue md:text-4xl" data-id="element-21" data-mp="gk2l1ifsrdes">🎁 5 Exclusive Bonuses</h2>
          <p className="mt-4 text-brand-gray" data-id="element-22" data-mp="ldezx0uoc5uc">Valued at <span className="font-bold text-brand-purple line-through" data-id="element-23" data-mp="qb6ygdptqq7i">$185 USD</span> — yours at no extra cost today.</p>
        </div>
        <div className="space-y-3" data-id="element-24" data-mp="vb2vft03thdk">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.06] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-25" data-mp="108uv596zq7sb" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue font-serif font-bold text-white" data-id="element-26" data-mp="aj4lgn6g9ah7">{index + 1}</span>
              <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="h-20 w-14 shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" data-id="element-27" data-mp="kc3mj4j4uthp" />
              <div className="min-w-0 flex-1" data-id="element-28" data-mp="tb74g56kd2um"><h3 className="font-bold leading-snug text-brand-blue" data-id="element-29" data-mp="taf7or18cz2r">{bonus.title}</h3><p className="mt-1 text-xs" data-id="element-30" data-mp="odf36kk144dr"><span className="text-brand-gray" data-id="element-31" data-mp="obubd2p3mzjl">{bonus.description}</span><span className="ml-2 font-semibold text-brand-purple line-through" data-id="element-32" data-mp="139mpbqezzfvo">value {bonus.price}</span><span className="ml-2 font-extrabold text-brand-teal" data-id="element-33" data-mp="yb2zhexa9jy1">FREE</span></p></div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}